import styled, { css } from 'styled-components'

interface ISkillAnswerProps {
  isSelected?: boolean
}

export const Container = styled.div`
background-color: white;
padding: 1rem;
`

export const HeaderContainer = styled.div`
display: flex;
justify-content: space-between;
border-bottom: 3px solid var(--c4);
padding: 2rem;
background-color: white;
align-items: center;

img{
  max-height: 10rem;
  max-width: 10rem;
  object-fit: scale-down;
}
`

export const SkillQuestion = styled.div`
  padding-bottom: 2rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid var(--c4);
  div {
    display: flex;
    align-items: baseline;
    h3 {
      margin: 2rem 1rem 1rem;
      font-weight: normal;
      color: black;
      font-size: 1.5rem;
    }
    span {
      color: var(--terc3);
    }
  }
  div + div {
    margin-top: 0.5rem;
  }
`

export const SkillAnswer = styled.button<ISkillAnswerProps>`
  background: var(--c2);
  border-radius: 0.25rem;
  padding: 1rem 2rem;
  border: 0;
  outline: 0;
  display: flex;
  width: 100%;
  align-items: center;
  margin-top: 0.5rem;
  svg {
    font-size: 1.5rem;
    color: var(--c4);
    ${(props) =>
      props.isSelected &&
      css`
        color: var(--v2);
      `};
  }
  span {
    margin-left: 1rem;
    color: black;
    font-size: 1rem;
  }
`

export const ComentarioContainer = styled.div`
  h3 {
    margin: 2rem 1rem 1rem;
    font-weight: normal;
    color: black;
    font-size: 1.5rem;
  }
  textarea {
    background: white;
    border-radius: 0.25rem;
    padding: 1rem 2rem;
    border: 1;
    border-color: var(--c4);
    outline: 0;
    display: flex;
    width: 100%;
    min-height: 8rem;
    margin-top: 0.5rem;
    font-size: 1rem;
    color:black;
  }
`
